import { Row, Col, Button, Tag, Typography } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DataGrid from 'components/theme_components/DataGrid';
import HeroTitle from 'components/theme_components/HeroTitle';
import Title from 'components/Title';
import DF from 'DisplayFramework';
import {
  ArrowDownOutlined,
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  RightOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { useContext, useMemo, useState } from 'react';
import { FilterConfig, FilterValues } from 'types';
import { useQuery } from 'react-query';
import {
  getParTaxList,
  ParTaxListParams,
  ParTaxResponse2,
  updateParRateStatus,
  updateParTaxStatus,
} from 'services/parametersService';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import ParListSelect from 'components/ParListSelect';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ParTaxeModal from './ParTaxeModal';
import ModalSFS from 'components/theme_components/ModalSFS';
import IPen from 'icons/IPen';
import ExportXLS from 'components/theme_components/ExportXLS';
import StatCard from 'components/theme_components/StatCard';
import ParTaxeValueModal from './ParTaxeValueModal';
import { dateToString } from 'utils/utilsSFS';
import moment from 'moment';
import { toRate } from 'utils/utils';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { AuthContext } from 'components/Auth/Auth';
import Notifications from 'components/theme_components/Notifications';

export type ParTaxeListProps = {
  color: string;
};

const ParTaxeList = ({ color }: ParTaxeListProps) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [addTaxeValue, setAddTaxeValue] = useState(false);
  const [filterValues, setFilterValues] = useState<FilterValues>({});
  const [selectedTaxeCode, setSelectedTaxeCode] = useState<any>('');
  
  const [modalVisible, setModalVisible] = useState(false);
  const { isInspect } = useContext(AuthContext);
  const getSearchParams = () => {
    const formattedcreationdate=filterValues.creationdate?moment(filterValues.creationdate).date:"";
    const formattedbegindate=filterValues.begindate?(filterValues.begindate).format('YYYY-MM-DD'):"";
    const formattedenddate=filterValues.enddate?filterValues.enddate.format('YYYY-MM-DD'):"";
console.log({formattedcreationdate})

    return {
      creationdate:formattedcreationdate || ('' as any),
      itaxlabel: filterValues.itaxlabel || ('' as any),
      taxtype: filterValues.taxtype || ('' as any),
      begindate: formattedbegindate|| ('' as any),
      enddate: formattedenddate|| ('' as any),
      taxflow: filterValues.taxflow || ('' as any),
    };
  };
  const [form] = useForm();

  const initialSearchParams: ParTaxListParams = getSearchParams();
  const [SearchParams, SetSearchParams] =
    useState<ParTaxListParams>(initialSearchParams);

  const {
    data: taxs,
    refetch,
    isFetching,
  } = useQuery(
    ['getParTaxList', SearchParams],
    () => getParTaxList(SearchParams).then((res) => res.list || []),
    { refetchOnMount: true }
  );
  const filterConfig: FilterConfig[] = [
    {
      key: 'creationdate',
      label: 'creationdate',
      type: 'date',
      placeholder: 'Date de Creation',
    },

    {
      key: 'itaxlabel',
      label: 'itaxlabel',
      type: 'text',
      placeholder: 'nom de tax',
    },
    {
      key: 'SFSTAXTYPE',
      label: 'taxtype',
      type: 'select',
      placeholder: 'Type de tax',
    },

    {
      key: 'begindate',
      label: 'begindate',
      type: 'date',
      placeholder: 'Date debut',
    },
    {
      key: 'enddate',
      label: 'enddate',
      type: 'date',
      placeholder: 'Date fin',
    },
    {
      key: 'TAXFLOW',
      label: 'taxflow',
      type: 'select',
      placeholder: 'Facturation',
    },
  ];

  const columns = [
    {
      dataIndex: 'creationdate',
      key: 'creationdate',
      width: '150px',
    },
    {
      dataIndex: 'taxlabel',
      key: 'taxlabel',
      width: '150px',
    },
    {
      dataIndex: 'partaxrate',
      key: 'partaxrate',
      width: '100px',
      render: (val: number) => {
        return toRate(val);
      },
    },
    {
      dataIndex: 'partaxtypelabel',
      key: 'partaxtypelabel',
      width: '200px',
    },
    {
      dataIndex: 'begindate',
      key: 'begindate',
      width: '150px',
      render: (val: string) => {
        if (val?.length > 0) {
          return moment(val).format('YYYY-MM-DD');
        }
      },
    },
    {
      dataIndex: 'enddate',
      key: 'enddate',
      width: '150px',
      render: (val: string) => {
        if (val?.length > 0) {
          return moment(val).format('YYYY-MM-DD');
        }
      },
    },
    {
      dataIndex: 'taxflow',
      key: 'taxflow',
      width: '150px',
    },
    {
      dataIndex: 'taxdescription',
      key: 'taxdescription',
    },
    {
      title: '',
      key: 'arrow',
      width: '80px',

      render: (record: ParTaxResponse2) => (
        <ModalSFS
          className="color-gray"
          trigger={({ setVisible }) => (
            <IPen
              onClick={() => setVisible(true)}
              style={{
                cursor: 'pointer',
              }}
            />
          )}
          title="updaterate"
          footer
          width={560}
        >
          <ParTaxeValueModal
            setVisible={() => false}
            data={record} // Pass the entire row data directly
            refetch={() => {
              refetch();
            }}
          />
        </ModalSFS>
      ),
      onHeaderCell: () => ({
        style: { paddingLeft: '12px' },
      }),
    },
  ];


   const onSelectChange = (
      selectedRowKeys: React.Key[],
      selectedRows: any[]
    ) => {
      setSelectedRows(selectedRows);
      setSelectedTaxeCode(selectedRows[0].taxcode);
      console.log(selectedRows);
      setIsDisabled(selectedRows.length === 0);
    };
  const handleFilterSearch = (values: any) => {
    console.log('Filter values:', values);
    SetSearchParams(values);
  };

  const handleFilterReset = () => {
    setFilterValues({});
    form.resetFields();
  };
  return (
    // <DF.Provider pagcode="partaxe">
    <DF.Provider pagcode="taxlist">
      <div className="bg-color-gray">
        <HeroTitle
          form={form}
          color={color}
          title="partaxeList"
          showFilter
          display
          filterConfig={filterConfig}
          onFilterSearch={handleFilterSearch}
          onFilterReset={handleFilterReset}
          className="productlist"
          noTitleOverlay
        />

        <div className="ut-title-page no-after globalvision">
          {addTaxeValue && (
            <Row justify="space-between" gutter={16} align="middle">
              <Col span={24}>
                <StatCard
                  title=""
                  value="Veuillez ajouter la valeur du taxe."
                  variant="notif"
                  className="mb-8 staticNotf mt-8"
                  valueStyle={{
                    backgroundColor: '#F7C0A929',
                  }}
                  width="100%"
                />
              </Col>
            </Row>
          )}
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: '15px' }}
          >
            <Col className="d-flex justify-start align-center">
              <Button
                disabled={isDisabled}
                className={
                  !isDisabled
                    ? 'no-border-radius  filter-item ant-btn-outline-primary bg-color-hover'
                    : 'no-border-radius  filter-item '
                }
                icon={<CloseOutlined />}
                 onClick={() => {
                      setModalVisible(true);
                    }}
              >
                <GetLabel label="delettaxe" /> ({selectedRows.length})
              </Button>
              <ModalSFS
                className="color-gray"
                trigger={({ setVisible }) => (
                  <Button
                    className="no-border-radius ant-btn-outline-primary ml-2 filter-item ant-btn-add bg-color-hover"
                    onClick={() => setVisible(true)}
                    icon={<PlusOutlined />}
                  >
                    <GetLabel label="addtaxe" />
                  </Button>
                )}
                title="addtaxe"
                footer
                width={600}
              >
                <ParTaxeModal
                  setVisible={() => false}
                  setAddTaxeValue={setAddTaxeValue}
                  refetch={() => {
                    refetch();
                  }}
                />
              </ModalSFS>
            </Col>
            <Col span={5} className="d-flex justify-end align-center">
              <ExportXLS data={taxs || []} filename="Taxes" />
            </Col>
          </Row>

          <DataGrid
            columns={columns}
            dataSource={taxs}
            rowKey="taxid"
            hideFilters
            hideTitle
            rowSelection={{
              type: 'checkbox',
              onChange: onSelectChange,
            }}
            isLoading={isFetching}
            pagination={{
              pageSize: 10,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} sur ${total}`,
              showSizeChanger: true,
            }}
          />
        </div>
         <ConfirmModal
            visible={modalVisible}
            status="error"
            message="Êtes-vous sûr de vouloir supprimer cette taxe ?"
            onConfirm={() => {
              updateParTaxStatus({
                taxcode: selectedTaxeCode,
                taxstatus: 'TERM',
              }).then((res) => {
                Notifications({
                  status: res.code,
                  message: 'La taxe a été supprimée avec succès.',
                  description: res.description,
                  duration: 3,
                  placement: 'top',
                });
                setModalVisible(false);
              });
            }}
            onCancel={() => !isInspect && setModalVisible(false)}
            className="modalConfirmOrCancel"
          />
      </div>
    </DF.Provider>
  );
};

export default ParTaxeList;
